module.exports = __webpack_public_path__ + "static/media/trimble.2da167cd.png";